import type { SurveyBlockConfig } from './types';

export const DEFAULT_SURVEY_BLOCK: SurveyBlockConfig = {
  format: 'text',
  message: 'Conta pra gente como foi sua experiência? Leva 1 minuto. ',
  linkLabel: 'Responder pesquisa',
  bannerUrl: '',
  bannerAlt: 'Responder pesquisa',
};

function escapeHtml(value: string): string {
  return value.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
}

/**
 * HTML que entra no lugar de `{{bloco_pesquisa}}`. Só nas lojas com pesquisa
 * transacional (`regraCartao.hasSurvey`); nas outras a variável vira vazio.
 * Tabela fechada, com a linha divisória no fim, para valer em qualquer ponto
 * do template. O `link` padrão fica como variável para o backend trocar.
 */
export function renderSurveyBlock(block: SurveyBlockConfig, link = '{{link_pesquisa}}'): string {
  const linkStyle = 'color:#127DB3;font-family:sans-serif;font-size:17px;font-weight:400;line-height:160%';
  const rule = '<hr color="#E0E0E0" align="center" width="100%" size="1" noshade style="margin:0;padding:0">';
  const banner = block.format === 'banner' && block.bannerUrl.trim();
  const inner = banner
    ? `<a href="${link}" target="_blank" style="display:block;text-decoration:none"><img src="${escapeHtml(block.bannerUrl.trim())}" alt="${escapeHtml(block.bannerAlt || block.linkLabel)}" width="100%" style="display:block;width:100%;max-width:100%;height:auto;border:0;border-radius:8px"></a>`
    : `${escapeHtml(block.message)}<a href="${link}" target="_blank" style="${linkStyle}">${escapeHtml(block.linkLabel)}</a>`;
  return (
    '<table role="presentation" width="100%" cellpadding="0" cellspacing="0" style="border-collapse:collapse;width:100%">' +
    `<tr><td align="center" valign="top" style="padding:20px 0 25px;font-family:sans-serif;font-size:17px;font-weight:400;line-height:160%;color:#000000">${inner}</td></tr>` +
    `<tr><td align="center" valign="top">${rule}</td></tr></table>`
  );
}
